<template>
  <el-dialog title="导入达人信息" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
    <div class="content">
      <i :class="success ? 'el-icon-success success' : 'el-icon-error error'"></i>
      <div class="info">
        <div v-if="success">导入成功！共 <span class="success">{{ result.success_count }}条</span> 数据</div>
        <div v-else>导入失败！</div>
        <div v-if="deficiency">检测到 <span class="deficiency">{{ result.fail_count }}条</span> 数据错误，请下载错误报告，修改后重新上传</div>
        <div v-if="error">请确认是否按照模版文件上传</div>
      </div>
    </div>
    <span slot="footer">
      <el-tooltip placement="top" v-if="!success">
        <img slot="content" :src="baseInfo.anchor_fail_code" alt="" width="160" height="160">
        <span class="fz-14 mr-20 link yx-color-text-regular">遇到困难？联系客服</span>
      </el-tooltip>
      <el-button type="primary" @click="btnHandler" :loading="loading">{{ btnText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { exportAddFail } from '@/api/talentCRM'
import mixin from '@/mixins';
export default {
  name: 'importResultDialog',
  mixins: [mixin],
  data () {
    return {
      dialogVisible: false,
      result: {},
      loading: false
    }
  },
  computed: {
    success() {
      const { code, fail_count } = this.result
      return code === 0 && fail_count === 0
    },
    error() {
      return this.result.code !== 0
    },
    deficiency() {
      const { code, fail_count } = this.result
      return code === 0 && fail_count !== 0
    },
    btnText() {
      const { success, error, deficiency } = this
      if(success) return '确认'
      if(error) return '重新导入'
      if(deficiency) return '下载错误报告'
    }
  },
  methods: {
    show(result) {
      this.result = result
      this.dialogVisible = true
    },
    handleClose() {
      this.result = {}
      this.dialogVisible = false
    },
    async btnHandler() {
      const { error, deficiency } = this
      const { fail_id } = this.result
      if(deficiency) {
        try {
          this.loading = true;
          const {download_url} = await exportAddFail({ fail_id });
          this.loading = false;
          window.open(download_url, "_blank");
        } catch (error) {
          if(error.code === -1) {
            this.$message.error(error.message);
          }
          this.loading = false;
        }
        return;
      }
      this.handleClose()
      if(error) this.$emit('showImportDialog')
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  .info {
    flex: 1;
    font-size: 14px;
    color: #1D1F23;
    margin-left: 4px;
    line-height: 24px;
    .success {
      color: #0053DB;
    }
    .deficiency {
      color: #FA2714;
    }
  }
  i {
    font-size: 24px;
  }
  .success {
    color: #52C41A;
  }
  .error {
    color: #E84335;
  }
}
</style>
